import React from "react";
import { Link } from "react-router-dom";
import { XCircle, Home, Heart } from "lucide-react";
import { Button } from "../components/ui/button";

const PaymentCancel = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6">
      <div className="max-w-lg w-full bg-white rounded-2xl border border-slate-200 shadow-xl p-10 md:p-14 text-center">
        <div className="w-20 h-20 rounded-full bg-slate-100 border-2 border-slate-200 flex items-center justify-center mx-auto">
          <XCircle className="w-10 h-10 text-slate-500" />
        </div>
        <h1 className="mt-6 font-serif-display text-3xl md:text-4xl font-extrabold text-[#0a3161]">
          Donation Canceled
        </h1>
        <p className="mt-4 text-slate-600 leading-relaxed">
          No payment was made and you have not been charged. If you had trouble with checkout, please
          try again or contact the campaign.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/#donate">
            <Button className="bg-[#b22234] hover:bg-[#8f1a29] text-white rounded-full h-12 px-8 font-oswald font-semibold uppercase tracking-[0.14em]">
              <Heart className="w-4 h-4 mr-2" />
              Try Again
            </Button>
          </Link>
          <Link to="/">
            <Button variant="outline" className="border-[#0a3161] text-[#0a3161] hover:bg-[#0a3161] hover:text-white rounded-full h-12 px-8 font-oswald font-semibold uppercase tracking-[0.14em]">
              <Home className="w-4 h-4 mr-2" />
              Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
